export var store = {
    auth: {
        type: null,
        token: null,
    },
    visitor: {
        name: null,
        phone: null,
    },
    school: {
        id: null,
        name: null,
        prof_url: null,
    },
    classrooms: null,
    available: null,
    available_time: null,
    exclusion_date: [],
}